import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Rview from "@/components/routerView/index.vue";
import { filterRoutesByPermissions } from "@/utils/routePermission";
import store from "@/store";
import { UserModule } from "@/model/user";

Vue.use(VueRouter);

export const routes: Array<RouteConfig> = [
  {
    path: "/login",
    meta: {
      title: "登录",
      without_auth: true,
    },
    component: () => import("@/views/login/index.vue"),
  },
];

export const asyncRoutes = [
  {
    path: "/",
    component: () => import("@/components/global/index.vue"),
    children: [
      {
        path: "",
        redirect: "home",
      },
      {
        path: "home",
        name: "home",
        meta: {
          title: "首页",
          cache: false,
        },
        component: () => import("@/views/home/index.vue"),
      },
      {
        path: "region",
        name: "region",
        meta: {
          title: "区域管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "区域列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/region/index.vue"),
          },
          {
            path: "edit",
            meta: {
              title: "新增区域",
              titleEdit: "编辑区域",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/region/edit/index.vue"),
          },
        ],
      },
      {
        path: "store",
        name: "store",
        meta: {
          title: "门店管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "门店列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/store/index.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "门店详情",
              titleEdit: "门店分佣明细",
              cache: false,
              hideInMenu: true
            },
            component: () => import("@/views/store/detail/index.vue"),
          },
          {
            path: "edit",
            meta: {
              title: "新增门店",
              titleEdit: "编辑门店",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/store/edit/index.vue"),
          },
        ],
      },
      {
        path: "goods",
        name: "goods",
        meta: {
          title: "商品管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "商品列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/goods/index.vue"),
          },
          {
            path: "edit",
            meta: {
              title: "添加商品",
              titleEdit: "编辑商品",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/goods/edit/index.vue"),
          },
        ],
      },
      {
        path: "category",
        name: "category",
        meta: {
          title: "分类管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "分类列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/category/goods/index.vue"),
          },
          {
            path: "edit",
            meta: {
              title: "添加分类",
              titleEdit: "编辑分类",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/category/goods/edit/index.vue"),
          },
        ],
      },
      {
        path: "order",
        name: "order",
        meta: {
          title: "订单管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "订单列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/order/index.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "订单详情",
              titleEdit: "订单详情",
              cache: false,
              hideInMenu: true,
            },
            component: () => import("@/views/order/edit/index.vue"),
          },
          {
            path: "gift",
            meta: {
              title: "赠送订单列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/order/gift/index.vue"),
          },
          {
            path: "print",
            meta: {
              title: "订单打印申请列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/order/print/index.vue"),
          },
        ],
      },
      {
        path: "user",
        name: "user",
        meta: {
          title: "用户管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "用户列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/user/index.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "用户详情",
              titleEdit: "用户流水明细",
              cache: false,
              hideInMenu: true,
            },
            component: () => import("@/views/user/detail/index.vue"),
          },
          {
            path: "member",
            meta: {
              title: "用户会员",
              titleEdit: "用户会员",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/user/member/index.vue"),
          },
          {
            path: "edit",
            meta: {
              title: "添加用户",
              titleEdit: "编辑用户",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/user/edit/index.vue"),
          },
        ],
      },
      {
        path: "auth",
        meta: {
          title: "账号管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "admin",
            meta: {
              title: "管理员管理",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/auth/admin/index.vue"),
          },
          {
            path: "admin/edit",
            meta: {
              title: "添加管理员",
              titleEdit: "编辑管理员",
              cache: false,
              hideInMenu: true,
            },
            component: () => import("@/views/auth/admin/edit/index.vue"),
          },
          {
            path: "role",
            meta: {
              title: "角色管理",
              cache: false,
            },
            component: () => import("@/views/auth/role/index.vue"),
          },
          {
            path: "role/edit",
            meta: {
              title: "添加角色",
              titleEdit: "编辑角色",
              cache: false,
              hideInMenu: true,
            },
            component: () => import("@/views/auth/role/edit/index.vue"),
          },
        ],
      },
      {
        path: "partner",
        meta: {
          title: "合伙人管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "合伙人列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/partner/index.vue"),
          },
          {
            path: "edit",
            meta: {
              title: "添加合伙人",
              titleEdit: "编辑合伙人",
              cache: false,
              hideInMenu: true,
            },
            component: () => import("@/views/partner/edit/index.vue"),
          },
        ],
      },
      {
        path: "meal",
        name: "meal",
        meta: {
          title: "储值套餐",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "套餐列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/meal/index.vue"),
          },
          {
            path: "edit",
            meta: {
              title: "添加套餐",
              titleEdit: "编辑套餐",
              cache: false,
              hideInMenu: true,
            },
            component: () => import("@/views/meal/edit/index.vue"),
          },
        ],
      },
      {
        path: "warehouse",
        name: "warehouse",
        meta: {
          title: "仓库管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "out",
            meta: {
              title: "出库管理",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/warehouse/out/index.vue"),
          },
          {
            path: "put",
            meta: {
              title: "入库管理",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/warehouse/put/index.vue"),
          },
          {
            path: "approach",
            meta: {
              title: "进场管理",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/warehouse/approach/index.vue"),
          },
          {
            path: "quality",
            meta: {
              title: "质检管理",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/warehouse/quality/index.vue"),
          },
        ],
      },
      {
        path: "meal_record",
        name: "meal_record",
        meta: {
          title: "充值管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "充值列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/meal_record/index.vue"),
          },
        ],
      },
      {
        path: "amount",
        name: "amount",
        meta: {
          title: "财务管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "财务列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/amount/index.vue"),
          },
        ],
      },
      {
        path: "settings",
        name: "settings",
        meta: {
          title: "系统设置",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "系统设置",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/settings/index.vue"),
          },
          {
            path: "edit",
            meta: {
              title: "出入库配置",
              titleEdit: "编辑出入库配置",
              cache: false,
              hideInMenu: true,
            },
            component: () => import("@/views/settings/edit/index.vue"),
          },
        ],
      },
      {
        path: "banner",
        name: "banner",
        meta: {
          title: "轮播图管理",
          cache: false,
        },
        component: Rview,
        children: [
          {
            path: "",
            meta: {
              title: "轮播图列表",
              cache: false,
              hideInMenu: false,
            },
            component: () => import("@/views/banner/index.vue"),
          },
          {
            path: "edit",
            meta: {
              title: "新增轮播图",
              titleEdit: "编辑轮播图",
              cache: false,
            },
            component: () => import("@/views/banner/edit/index.vue"),
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 添加一个标志来防止重复添加路由
let routesAdded = false;

// 路由守卫
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.without_auth) {
    next();
    return;
  } else {
    if (UserModule.token !== null) {
      const hasRoles =
        store.state.permissions && (store.state.permissions as any).length > 0;
      console.log(store.state.permissions, "测试");
      if (hasRoles) {
        next();
      } else {
        try {
          // 获取用户信息
          // debugger
          const permissions = await UserModule.auth;
          if (permissions == "") {
            alert("当前账号没有任何权限，请联系管理员");
            UserModule.logout();
            store.state.permissions = "";
            next(`/login`);
            return;
          }
          // 添加动态路由
          const accessRoutes = await addDynamicRoutes(permissions);
          routesAdded = true;
          router.addRoutes(accessRoutes);
          // 重新导航到目标路由
          next({ path: to.path, replace: true });
          return;
        } catch (error) {
          // 清除用户登录信息后，回跳到登录页去
          UserModule.logout();
          store.state.permissions = "";
          next(`/login`);
          // NProgress.done()
        }
      }
    } else {
      // 如果用户未登录，跳转到登录页面
      next(`/login`);
    }
  }
});

// 动态添加路由
export function addDynamicRoutes(permissions: string) {
  console.log("Adding dynamic routes with permissions:", permissions);
  store.commit("setPermissions", permissions);
  // 如果路由已经添加过，直接返回
  if (routesAdded) {
    return [];
  }

  // 过滤路由
  const accessRoutes = filterRoutesByPermissions(asyncRoutes, permissions);
  console.log("Filtered routes:", accessRoutes);

  // 添加路由
  router.addRoutes(accessRoutes);

  // 保存路由到 store
  store.commit("saveRoute", accessRoutes);
  store.commit("setPermissions", permissions);

  return accessRoutes;
}

export { router };
export default router;
